// Navartha — route helpers shared by header, footer and pages.
// Language prefix convention: EN routes have no prefix, ID routes live under /id.

export const homePath = (lang) => (lang === 'id' ? '/id' : '/');

export const clinicPath = (lang) =>
  lang === 'id' ? '/id/business-clinic' : '/business-clinic';

export const receivedPath = (lang) =>
  lang === 'id' ? '/id/business-clinic/received' : '/business-clinic/received';

export const privacyPath = (lang) => (lang === 'id' ? '/id/privacy' : '/privacy');

// Returns the equivalent page path in the other language, preserving nothing else.
export const switchPath = (pathname, target) => {
  const isId = pathname.startsWith('/id');
  if (target === 'id') {
    return isId ? pathname : `/id${pathname === '/' ? '' : pathname}`;
  }
  return isId ? pathname.slice(3) || '/' : pathname;
};
